import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  useDisclosure,
} from '@chakra-ui/react';
import {
  FiAlertTriangle,
  FiCheck,
  FiCheckCircle,
  FiClock,
  FiFileText,
  FiFilter,
  FiSearch,
  FiXCircle,
} from 'react-icons/fi';
import ButtonFilterSelectiveProcess from './buttonFilter';
import React, { useRef } from 'react';

interface IOwnProps {
  onFinalSearch: React.Dispatch<React.SetStateAction<string>>;
  onSelectedButton: React.Dispatch<React.SetStateAction<string | undefined>>;
  selectedButton?: string;
}

const FilterSelectiveProcess: React.FC<IOwnProps> = ({ selectedButton, onFinalSearch, onSelectedButton }) => {
  const searchInputMobileRef = useRef<HTMLInputElement>(null);
  const { isOpen, onToggle, onClose } = useDisclosure();

  const onSelectedFilter = (value: string) => {
    onSelectedButton((old) => (old === value ? undefined : value));
    onClose();
  };

  return (
    <Box w="100%" mx="auto">
      <InputGroup>
        <Input
          type="text"
          h="35px"
          ref={searchInputMobileRef}
          borderRadius="md"
          placeholder="Buscar processo seletivo..."
          variant="filled"
          border="1px solid"
          borderColor="#c0c0c0"
          focusBorderColor="blue.500"
          bg="gray.50"
          _hover={{ bg: 'gray.100' }}
          _focus={{ bg: 'white' }}
        />
        <InputRightElement
          w="fit-content"
          h="35px"
          children={
            <Box as="button" px={4} h="100%" margin="auto">
              <FiSearch color="gray.600" />
            </Box>
          }
          onClick={() => {
            if (searchInputMobileRef.current) onFinalSearch(searchInputMobileRef.current.value);
          }}
        />
      </InputGroup>
      <Accordion index={isOpen ? 0 : []} mt={1} allowMultiple>
        <AccordionItem border="1px solid #c0c0c0" borderRadius="md">
          <h2>
            <AccordionButton h="35px" color="inherit" onClick={onToggle}>
              <Flex as="span" flex="1" fontSize="smaller" textAlign="left" align="center" gap={1}>
                <FiFilter size={15} />
                {selectedButton || 'Filtrar por status'}
              </Flex>
              <AccordionIcon />
            </AccordionButton>
          </h2>
          <AccordionPanel p={1}>
            <ButtonFilterSelectiveProcess
              value="Inscrições Abertas"
              icon={<FiCheckCircle />}
              onSelectedButton={onSelectedFilter}
              isSelected={selectedButton === 'Inscrições Abertas'}
            />
            <ButtonFilterSelectiveProcess
              value="Em Andamento"
              icon={<FiClock />}
              onSelectedButton={onSelectedFilter}
              isSelected={selectedButton === 'Em Andamento'}
            />
            <ButtonFilterSelectiveProcess
              value="Homologado"
              icon={<FiFileText />}
              onSelectedButton={onSelectedFilter}
              isSelected={selectedButton === 'Homologado'}
            />
            <ButtonFilterSelectiveProcess
              value="Finalizado"
              icon={<FiCheck />}
              onSelectedButton={onSelectedFilter}
              isSelected={selectedButton === 'Finalizado'}
            />
            <ButtonFilterSelectiveProcess
              value="Suspenso"
              icon={<FiAlertTriangle />}
              onSelectedButton={onSelectedFilter}
              isSelected={selectedButton === 'Suspenso'}
            />
            <ButtonFilterSelectiveProcess
              value="Cancelado"
              icon={<FiXCircle />}
              onSelectedButton={onSelectedFilter}
              isSelected={selectedButton === 'Cancelado'}
            />
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Box>
  );
};

export default FilterSelectiveProcess;
